import { useEffect, useState } from 'react';

import { getConfig } from '@edx/frontend-platform';
import { fetchAuthenticatedUser, getAuthenticatedUser } from '@edx/frontend-platform/auth';
import PropTypes from 'prop-types';

/**
 * This wrapper redirects the requester to our default redirect url if they are
 * already authenticated.
 */
const UnAuthOnlyRoute = ({ children }) => {
  const [authUser, setAuthUser] = useState({});
  const [isReady, setIsReady] = useState(false);

  const isSpaceDashboard = getConfig().IS_SPACE_DASHBOARD;
  const isHubDashboard = getConfig().IS_HUB_DASHBOARD;
  const enableProfileSwitcher = getConfig().ENABLE_PROFILE_SWITCHER;

  let dashboardPath; // override for dashboard path

  if (isHubDashboard) {
    dashboardPath = '/xened/dashboard/hub';
  } else if (isSpaceDashboard) {
    dashboardPath = '/xened/dashboard/space';
  } else {
    dashboardPath = '/xened/dashboard';
  }
  useEffect(() => {
    fetchAuthenticatedUser({ forceRefresh: !!getAuthenticatedUser() }).then((authenticatedUser) => {
      setAuthUser(authenticatedUser);
      setIsReady(true);
    });
  }, []);

  if (isReady) {
    if (authUser && authUser.username) {
      if (enableProfileSwitcher && document.querySelector('.veritas-header a.homeIcon')) {
        document.querySelector('.veritas-header a.homeIcon').click(); // redirect to overridden dashboard path by clicking on home icon
      } else {
        global.location.href = getConfig().LMS_BASE_URL.concat(dashboardPath); // redirect to overridden dashboard path
      }
      return null;
    }

    return children;
  }

  return null;
};

UnAuthOnlyRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default UnAuthOnlyRoute;
